import React from "react";

import Navbar from "./navBar";
import { Link } from "react-router-dom";
import { newTab } from "../App";
import FormikForm from "./formikForm";

import "boxicons";
import "./styles/contact.css";

function Contact() {
  return (
    <div>
      <Navbar />
      {/* <!-- ======= Contact Section ======= --> */}
      <section id="contact" className="contact">
        <div className="container">
          <div className="section-title">
            <h2>Contact</h2>
            <p>Contact Me</p>
          </div>

          <div className="row mt-2">
            <div className="col-md-6 d-flex align-items-stretch">
              <div className="info-box">
                <div className="i-box">
                  <box-icon name="home-smile" color="orange"></box-icon>
                </div>
                <h3>My Address</h3>
                <p>Lagos, Nigeria</p>
              </div>
            </div>

            <div className="col-md-6 mt-4 mt-md-0 d-flex align-items-stretch">
              <div className="info-box">
                <div className="i-box">
                  <box-icon name="share-alt" color="orange"></box-icon>
                </div>
                <h3>Social Profiles</h3>
                <div className="social-links">
                  <Link onClick={() => newTab("https://twitter.com/EmIChEaLy")}>
                    <box-icon
                      type="logo"
                      name="twitter"
                      color="white"
                      size="sm"
                    ></box-icon>
                  </Link>

                  <Link onClick={() => newTab("https://m.facebook.com/home.php?paipv=0&eav=Afay4jGYtAJGT0GsW971ZCxLfwhXkMcJ19e23XlBxFDRm0RD1UsnYVjlcZbtpdqWGtM&_rdr&tbua=1")}>
                    <box-icon
                      type="logo"
                      name="facebook"
                      color="white"
                    ></box-icon>
                  </Link>

                  <Link onClick={() => newTab("https://www.instagram.com/emilychealy4/")}>
                    <box-icon
                      type="logo"
                      name="instagram"
                      color="white"
                    ></box-icon>
                  </Link>

                  <Link onClick={() => newTab("https://www.linkedin.com/in/emichealy/")}>
                    <box-icon
                      type="logo"
                      name="linkedin"
                      color="white"
                    ></box-icon>
                  </Link>

                  <a href="mailto:emilychealy4@gmail.com, emilychealy4@gmail.com">
                    <box-icon name="mail-send" color="white"></box-icon>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-6 mt-4 d-flex align-items-stretch">
              <div className="info-box">
                <div className="i-box">
                  <box-icon name="mail-send" color="orange"></box-icon>
                </div>
                <h3>Email Me</h3>
                <p>emilychealy4@gmail.com</p>
              </div>
            </div>
            <div className="col-md-6 mt-4 d-flex align-items-stretch">
              <div className="info-box">
                <div className="i-box">
                  <box-icon name="phone" color="orange"></box-icon>
                </div>
                <h3>Call Me</h3>
                <p>+234 7086292088</p>
              </div>
            </div>
          </div>
          <FormikForm />
        </div>
      </section>
      {/* <!-- End Contact Section --> */}
    </div>
  );
}

export default Contact;
